import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectServiceToQuote } from 'store/reducers/customerQuotes/action';
import { TableCustomQuote } from 'components';
import { Box } from '@mui/material';
import ApiServices from 'services';
import { Columns } from './columns';
import { SUB_SERVICES_ID } from 'commons/constants';

function SeaLcl() {
  const dispatch = useDispatch();
  const [seaLclList, setSeaLclList] = useState([]);
  const [loading, setLoading] = useState(false);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getDataQuotesFreight(SUB_SERVICES_ID.SEA_LCL, {
        pageNumber: 1,
        pageSize: 10,
      });
      setSeaLclList(data?.data || []);
    } catch (err) {
      console.warn('initData - getDataQuotesFreight', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    initData();
  }, []);

  const handleSelectedChange = (row, values) => {
    dispatch(selectServiceToQuote(values));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TableCustomQuote
        rows={seaLclList}
        headCells={Columns()}
        loading={loading}
        isHeader={false}
        isCheckbox={true}
        onSelectedChange={handleSelectedChange}
        checkedOnlyItem={true}
      />
    </Box>
  );
}
export { SeaLcl };
